import React, { Component } from 'react';
import './RpmScatterChart.css';

import { ScatterChart, CartesianGrid, XAxis, YAxis, ZAxis, Tooltip, Scatter } from 'recharts';
import moment from 'moment';

export default class RpmScatterChart extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  showTooltip = ({ active, payload }) => {
    if (window.event) {
      const { clientX, clientY } = window.event;
      let myTooltipElement = document.getElementById('myTooltip');

      if (myTooltipElement) {
        if (active) {
          myTooltipElement.classList.add('visible');
          myTooltipElement.style.top = clientY - 170 + 'px';
          myTooltipElement.style.left = clientX - 140 + 'px';

          this.props.buildTooltip(document.querySelector('#myTooltip .header'), document.querySelector('#myTooltip .content'), payload[0].payload);
        } else {
          myTooltipElement.classList.remove('visible');
        }
      }
    }
  };

  xTickFormatter = unixTime => moment(unixTime).format(this.props.dateFormat);

  yTickFormatter = value => value / 1000;

  render() {
    const { width, height, data, name, unitX, unitY, xAxisTicks } = this.props;

    const _data = data.map(this.props.mapFn);

    const DURATIONS = _data.map(d => d.z);

    return (
      <div className="RpmScatterChart">
        <ScatterChart width={width} height={height} margin={{ top: 20, right: 30, bottom: 10, left: -10 }}>
          <CartesianGrid />
          <XAxis
            axisLine={false}
            tickFormatter={this.xTickFormatter}
            type="number"
            scale="time"
            dataKey="x"
            unit={unitX}
            domain={[xAxisTicks[0], xAxisTicks[xAxisTicks.length - 1]]}
            ticks={xAxisTicks}
            tickSize={0}
          />
          <YAxis axisLine={false} tickFormatter={this.yTickFormatter} dataKey="y" unit={unitY} ticks={[0, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000]} tickSize={0} />
          <ZAxis dataKey="z" range={[Math.min(...DURATIONS) * 2, Math.max(...DURATIONS) * 2]} name="duration" />
          <Tooltip content={this.showTooltip} />
          <Scatter name={name} data={_data} fill="#49c6be" />
        </ScatterChart>
        <div className="myTooltip" id="myTooltip">
          <div className="myTooltipArrow" />
          <div className="myTooltipInner">
            <div className="header" />
            <div className="content" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmTabChart/RpmScatterChart/RpmScatterChart.js